module.exports = __webpack_public_path__ + "img/Lost_kingdom-update.ee671457.jpg";